// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__12MAE","content":"styles_content__38oUf","checkbox":"styles_checkbox__3qOHv","checkboxLabel":"styles_checkboxLabel__1KtHA"};